/* ============================================================
   Campaign Banner Products — Carousel Arrow Controller
   Custom Element: <cbp-carousel-wrapper>

   - Scrolls the product grid by one card width per click
   - Hides prev arrow on first slide, next arrow on last slide
   - Hides both arrows when all content fits without scrolling
   - Recalculates on resize / orientation change
   ============================================================ */

if (!customElements.get('cbp-carousel-wrapper')) {
  class CbpCarouselWrapper extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      this._initTimeout = setTimeout(() => {
        this.init();
      }, 0);
    }

    init() {
      this.grid = this.querySelector('.cbp__products-grid');
      this.prevBtn = this.querySelector('.cbp__carousel-arrow--prev');
      this.nextBtn = this.querySelector('.cbp__carousel-arrow--next');

      if (!this.grid || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this._scroll(-1));
      this.nextBtn.addEventListener('click', () => this._scroll(1));
      this.grid.addEventListener('scroll', this._onScroll, { passive: true });

      /* Initial check after layout settles */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this._onScroll());
      });

      /* Re-check on resize (orientation change, etc.) */
      this._ro = new ResizeObserver(() => this._onScroll());
      this._ro.observe(this.grid);
    }

    disconnectedCallback() {
      if (this._initTimeout) clearTimeout(this._initTimeout);
      if (this._ro) this._ro.disconnect();
      if (this.grid) this.grid.removeEventListener('scroll', this._onScroll);
    }

    _scroll(direction) {
      const card = this.grid.querySelector('.cbp__product-item');
      const gap = parseInt(getComputedStyle(this.grid).gap) || 0;
      const amount = card ? card.offsetWidth + gap : this.grid.offsetWidth * 0.75;
      this.grid.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    _onScroll() {
      const el = this.grid;
      const scrollLeft = Math.round(el.scrollLeft);
      const maxScroll = el.scrollWidth - el.clientWidth;
      const threshold = 2; /* px tolerance for rounding */

      const atStart = scrollLeft <= threshold;
      const atEnd = scrollLeft >= maxScroll - threshold;
      const noScroll = maxScroll <= threshold; /* content fits, no scrolling needed */

      /* Completely hide arrows when not available */
      this.prevBtn.hidden = atStart || noScroll;
      this.prevBtn.disabled = atStart || noScroll;

      this.nextBtn.hidden = atEnd || noScroll;
      this.nextBtn.disabled = atEnd || noScroll;
    }
  }

  customElements.define('cbp-carousel-wrapper', CbpCarouselWrapper);
}
